// extracted by mini-css-extract-plugin
export default {"cls1":"WithdrawnNotice-Box_cls1__kbN-w","cls2":"WithdrawnNotice-Box_cls2__dJIZd WithdrawnNotice-Box_cls1__kbN-w"};